import { render, staticRenderFns } from "./TransactionEventMobile.vue?vue&type=template&id=cb8ca512&scoped=true"
import script from "./TransactionEventMobile.vue?vue&type=script&lang=js"
export * from "./TransactionEventMobile.vue?vue&type=script&lang=js"
import style0 from "./TransactionEventMobile.vue?vue&type=style&index=0&id=cb8ca512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8ca512",
  null
  
)

export default component.exports